import type { TechlineCommentEntity } from '@packages/domain/techline/comments';

import { Icon, Typography } from '@packages/ui/shared';

/**
 * Props for the {@link CaseCommentRow} component.
 */
export type CaseCommentRowProps = {
    /** The comment data to display. */
    comment: TechlineCommentEntity;
};

/**
 * Renders a single comment row with user icon, author name/title, creation date, and message.
 *
 * @param props - {@link CaseCommentRowProps}
 * @returns the comment row JSX
 */
export function CaseCommentRow({ comment }: CaseCommentRowProps) {
    return (
        <div className="d-flex mt-5 flex-row">
            <Icon name="user" size={24} />
            <div className="d-flex flex-column ml-3 mr-3">
                <div className="d-flex align-items-center mb-1 flex-row">
                    <Typography color="blueOne" variant="h6">
                        {comment.jobTitle ? comment.jobTitle : ''}
                    </Typography>
                    <Typography color="blueOne" variant="h6">
                        {comment.fullName ? comment.fullName : ''}
                    </Typography>
                    <Typography color="textDarkSecondary" variant="caption">
                        {' '}
                        {comment.createdOn}
                    </Typography>
                </div>
                <Typography>{comment.message}</Typography>
            </div>
        </div>
    );
}
